<div id="hero-area" class="hero-area-bg" *ngIf="event">
  <div class="overlay"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-9 col-sm-12">
        <div class="contents text-center" data-aos="fade-up">
          <div class="icon">
            <i class="lni-mic"></i>


          </div>

          <p class="banner-info"> {{event.startDate | date:'mediumDate' }} - {{ event.venue }}</p>

          <h2 class="head-title"> {{event.name}}</h2>
          <p class="banner-desc">
            {{ event.topic}}</p>

          <div class="banner-btn">
            <a (click)="scrollToSection('eventForm')" class="btn btn-common">Register Now</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<section id="about" class="section-padding" *ngIf="event">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 col-md-12 col-xs-12">
        <div class="img-thumb">
          <img class="img-fluid" src="../../../assets/images/about/img1.png" alt="img1">
        </div>
      </div>
      <div class="col-lg-6 col-md-12 col-xs-12">
        <div class="about-content">
          <div>
            <div class="about-text">
              <h2>About The Event</h2>
              <p [innerHTML]="event.editorContent"></p>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>


<div class="ready-to-play">
  <video #bgvid class="stop" controls muted loop="true" preload="auto">
    <source src="../../../assets/images/video/event.webm" type="video/mp4">
  </video>
  <div id="polina" class="video-text">
    <div class="tb-t">
      <div class="tb-c">
        <div class="polina"> <button (click)="toggleVideo()">
            <i class="lni-play"></i>

          </button></div>
      </div>
    </div>
  </div>
</div>


<section id="information-bar" *ngIf="event">
  <div class="container">
    <div class="row inforation-wrapper">
      <div class="col-lg-4 col-md-6 col-xs-12">
        <ul>
          <li>
            <i class="lni-map-marker"></i>

          </li>
          <li><span><b>Location</b> {{ event.venue }}</span></li>
        </ul>
      </div>
      <div class="col-lg-4 col-md-6 col-xs-12">
        <ul>
          <li>
            <i class="lni-calendar"></i>
          </li>
          <li><span><b>Date &amp; Time</b> {{event.startDate | date: 'shortTime' }} - {{event.endDate | date:
              'shortTime' }}, {{event.startDate| date:
              'mediumDate' }}</span></li>
        </ul>
      </div>
      <div class="col-lg-4 col-md-6 col-xs-12">
        <ul>
          <li>
            <i class="lni-mic"></i>
          </li>
          <li><span><b>Speakers</b>Best Professionals</span></li>
        </ul>
      </div>

    </div>
  </div>
</section>


<section id="intro" class="intro section-padding" data-aos="zoom-in" data-aos-anchor-placement="center-left">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="section-title-header text-center">
          <h2 class="section-title wow fadeInUp animated" data-wow-delay="0.2s"
            style="visibility: visible;-webkit-animation-delay: 0.2s; -moz-animation-delay: 0.2s; animation-delay: 0.2s;">
            Why You Should Join?</h2>
          <p class="wow fadeInDown animated" data-wow-delay="0.2s"
            style="visibility: visible;-webkit-animation-delay: 0.2s; -moz-animation-delay: 0.2s; animation-delay: 0.2s;">
            Meetup is an invaluable opportunity to learn and grow! Engage with industry experts, expand your network,
            and gain insights that can elevate your skills. Don’t miss out on this chance to invest in your future!
            Meetup is an invaluable opportunity to learn and grow! Engage with industry experts, expand your network,
            and gain insights that can elevate your skills. Don’t miss out on this chance to invest in your future! </p>
        </div>
      </div>
    </div>
    <div class="row intro-wrapper">
      <div class="col-lg-4 col-md-6 col-xs-12">
        <div class="single-intro-text mb-70">
          <i class="lni-microphone"></i>
          <h3>Industry-Leading Experts</h3>
          <p>
            Learn from top experts and gain actionable insights to boost your expertise and stay competitive.          </p>
          <span class="count-number"></span>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 col-xs-12">
        <div class="single-intro-text mb-70">
          <i class="lni-gallery"></i>
          <h3>Connect and Collaborate</h3>
          <p>
            Meet peers and professionals to build connections that inspire and open doors for collaboration.           </p>
          <span class="count-number"></span>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-xs-12">
        <div class="single-intro-text mb-70">
          <i class="lni-heart"></i>
          <h3>Get Inspired</h3>
          <p>
            Leave energized with fresh ideas and practical strategies to elevate your work.          </p>
          <span class="count-number"></span>
        </div>
      </div>


    </div>
  </div>
</section>



<section id="team" class="section-padding text-center" *ngIf="eventSpeakers">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="section-title-header text-center">
          <h2 class="section-title wow fadeInUp animated " data-wow-delay="0.2s"
            style="visibility: visible;-webkit-animation-delay: 0.2s; -moz-animation-delay: 0.2s; animation-delay: 0.2s;">
            Our Speakers</h2>
          <p class="wow fadeInDown animated" data-wow-delay="0.2s"
            style="visibility: visible;-webkit-animation-delay: 0.2s; -moz-animation-delay: 0.2s; animation-delay: 0.2s;">
            Hear from industry experts who are at the forefront of innovation and excellence. Join us as we dive into inspiring presentations and thought-provoking panel discussions designed to empower, educate, and inspire. </p>
        </div>
      </div>
    </div>
    <div class="row justify-content-bt">

      <div class="col-lg-4 col-md-6 col-xs-12 mx-auto" *ngFor="let speaker of event.selectedSpeakers">

        <div class="team-item wow fadeInUp animated" data-wow-delay="0.2s"
          style="visibility: visible;-webkit-animation-delay: 0.2s; -moz-animation-delay: 0.2s; animation-delay: 0.2s;">
          <div class="team-img">
            <img class="img-fluid" [src]="getImageUrl(speaker.imageUrl)" style="width: 255px; height: 228px !important"
              alt="">

          </div>
          <div class="info-text">
            <h3><a href="#">{{ speaker.name }}</a></h3>
            <p>{{ speaker.bio }} {{speaker.company}}</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>


<section id="gallery" class="section-padding">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="section-title-header text-center">
          <h2 class="section-title wow fadeInUp animated" data-wow-delay="0.2s"
            style="visibility: visible; -webkit-animation-delay: 0.2s; -moz-animation-delay: 0.2s; animation-delay: 0.2s;">
            Event Gallery
          </h2>
          <p class="wow fadeInDown animated" data-wow-delay="0.2s"
            style="visibility: visible; -webkit-animation-delay: 0.2s; -moz-animation-delay: 0.2s; animation-delay: 0.2s;">
            Relive the highlights and moments from our past events. Experience the energy, interactive learning, and collaboration captured in our gallery. 
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div *ngFor="let img of galleryImages" class="col-md-6 col-sm-6 col-lg-3">
        <div class="gallery-box">
          <div class="img-thumb">
            <img class="img-fluid" [src]="getGalleryImageUrl(img.imageUrl)" alt="Event Image">
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section id="blog" class="section-padding" data-aos="fade-up">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="section-title-header text-center">
          <h2 class="section-title wow fadeInUp animated" data-wow-delay="0.2s"
            style="visibility: visible;-webkit-animation-delay: 0.2s; -moz-animation-delay: 0.2s; animation-delay: 0.2s;">
            Latest News</h2>
          <p class="wow fadeInDown animated" data-wow-delay="0.2s"
            style="visibility: visible;-webkit-animation-delay: 0.2s; -moz-animation-delay: 0.2s; animation-delay: 0.2s;">
            Stay informed with the latest developments in tech and innovation. From cutting-edge advancements in web frameworks to insights on global tech trends, our news section provides updates that keep you ahead of the curve. </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-md-6 col-xs-12">
        <div class="blog-item">
          <div class="blog-image">
            <a href="#">
              <img class="img-fluid" src="assets/images/blogs/cloud-disaster-banner.webp" alt="">
            </a>
          </div>
          <div class="descr">
            <div class="icon">
              <a href="/cloud-disaster-recovery">
                <i class="lni-arrow-right"></i>
              </a>
            </div>
            <h3 class="title">
              <a href="/cloud-disaster-recovery">
                Cloud Disaster Recovery: Proven Strategies Every IT Leader Should Know
              </a>
            </h3>
            <p>Explore best practices and proven approaches for cloud disaster recovery best practices and proven
              approaches for cloud disaster recovery</p>
          </div>
          <div class="meta-tags">
            <span class="date"><i class="lni-calendar"></i> July, 2024</span>
            <span class="comments"><i class="lni-comment-alt"></i> <a href="/cloud-disaster-recovery"> 450
                views</a></span>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-xs-12">
        <div class="blog-item">
          <div class="blog-image">
            <a href="/datacenterswithcloud-computing">
              <img class="img-fluid" src="assets/images/blogs/datacenters-image.webp" alt="">
            </a>
          </div>
          <div class="descr">
            <div class="icon">
              <a href="/datacenterswithcloud-computing">
                <i class="lni-arrow-right"></i>
              </a>
            </div>
            <h3 class="title">
              <a href="/datacenterswithcloud-computing">
                Modernize Your Data Centers with Cloud Computing: An imperative for today’s businesses
              </a>
            </h3>
            <p>Explore how cloud computing can solve key challenges of today's modern businesses</p>
          </div>
          <div class="meta-tags">
            <span class="date"><i class="lni-calendar"></i> July 2024</span>
            <span class="comments"><i class="lni-comment-alt"></i> <a href="/datacenterswithcloud-computing"> 450
                Views</a>
            </span>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-xs-12">
        <div class="blog-item">
          <div class="blog-image">
            <a href="/azure-deployments">
              <img class="img-fluid" src="../../../assets/images/blogs/azzure-banner-img.webp" alt="">
            </a>
          </div>
          <div class="descr">
            <div class="icon">

              <a href="/azure-deployments">
                <i class="lni-arrow-right"></i>
              </a>
            </div>
            <h3 class="title">
              <a href="/azure-deployments">
                Top 16 cloud security best practices that boost the overall security of your Azure deployments
              </a>
            </h3>
            <p>Read the top Azure Cloud security best practices from the experts to safeguard your cloud environment</p>
          </div>
          <div class="meta-tags">
            <span class="date"><i class="lni-calendar"></i> JUly, 2024</span>
            <span class="comments"><i class="lni-comment-alt"></i> <a href="/azure-deployments"> 450 Views</a></span>
          </div>
        </div>
      </div>
      <div class="col-12 text-center">
        <a href="/blogs" class="btn btn-common">View all Blog</a>
      </div>
    </div>
  </div>
</section>


<section id="sponsors" class="section-padding">
  <div class="overlay"></div>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="section-title-header text-center">
          <h2 class="section-title wow fadeInUp animated" data-wow-delay="0.2s"
            style="visibility: visible;-webkit-animation-delay: 0.2s; -moz-animation-delay: 0.2s; animation-delay: 0.2s;">
            Sponsors</h2>
          <p class="wow fadeInDown animated" data-wow-delay="0.2s"
            style="visibility: visible;-webkit-animation-delay: 0.2s; -moz-animation-delay: 0.2s; animation-delay: 0.2s;">
            Lorem ipsum dolor sit amet, in quodsi vulputate pro. Ius illum vocent mediocritatem an <br> cule dicta
            iriure at phaedrum.</p>
        </div>
      </div>
    </div>
    <div class="row mb-30 text-center wow fadeInDown animated" data-wow-delay="0.3s"
      style="visibility: visible;-webkit-animation-delay: 0.3s; -moz-animation-delay: 0.3s; animation-delay: 0.3s;">
      <div class="col-lg-6">
        <div class="sponsors-logo text-center">
          <a href=""><img src="../../../assets/images/homepage/section_logos/sarvani-logo.png" alt=""></a>
          <a href=""><img src="../../../assets/images/homepage/section_logos/newliscr-image.png" alt=""></a>

        </div>
      </div>
    </div>
  </div>
</section>



<section id="contact-map" class="section-padding" *ngIf="isPastEvent == false">
  <div class="container" id="eventForm">
    <div class="row">
      <div class="col-12">
        <div class="section-title-header text-center">
          <h2 class="section-title wow fadeInUp animated" data-wow-delay="0.2s"
            style="visibility: visible;-webkit-animation-delay: 0.2s; -moz-animation-delay: 0.2s; animation-delay: 0.2s;">
            Register</h2>
          <p class="wow fadeInDown animated" data-wow-delay="0.2s"
            style="visibility: visible;-webkit-animation-delay: 0.2s; -moz-animation-delay: 0.2s; animation-delay: 0.2s;">
            Lorem ipsum dolor sit amet, in quodsi vulputate pro. Ius illum vocent mediocritatem an <br> cule dicta
            iriure at phaedrum.</p>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-8 col-md-12 col-xs-12">
        <div class="container-form wow fadeInLeft animated" data-wow-delay="0.2s"
          style="visibility: visible;-webkit-animation-delay: 0.2s; -moz-animation-delay: 0.2s; animation-delay: 0.2s;">
          <div class="form-wrapper">

            <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
              <div class="row">
                <!-- First Name Field -->
                <div class="col-md-6 form-line">
                  <div class="form-group">
                    <input type="text" class="form-control" id="Name" formControlName="Name" placeholder="First Name"
                      [class.is-invalid]="isFormControlInvalid('Name')" aria-describedby="nameError" />
                    <div id="nameError" *ngIf="isFormControlInvalid('Name')" class="invalid-feedback">
                      {{ getErrorMessage('Name') }}
                    </div>
                  </div>
                </div>

                <!-- Email Field -->
                <div class="col-md-6 form-line">
                  <div class="form-group">
                    <input type="email" class="form-control" id="Email" formControlName="Email" placeholder="Email"
                      [class.is-invalid]="isFormControlInvalid('Email')" aria-describedby="emailError" />
                    <div id="emailError" *ngIf="isFormControlInvalid('Email')" class="invalid-feedback">
                      {{ getErrorMessage('Email') }}
                    </div>
                  </div>
                </div>

                <!-- Phone Field -->
                <div class="col-md-6 form-line">
                  <div class="form-group">
                    <input type="tel" class="form-control" id="Phone" formControlName="Phone" placeholder="Phone Number"
                      [class.is-invalid]="isFormControlInvalid('Phone')" aria-describedby="phoneError" />
                    <div id="phoneError" *ngIf="isFormControlInvalid('Phone')" class="invalid-feedback">
                      {{ getErrorMessage('Phone') }}
                    </div>
                  </div>
                </div>

                <!-- College Field -->
                <div class="col-md-6 form-line">
                  <div class="form-group">
                    <input type="text" class="form-control" id="College" formControlName="College"
                      placeholder="College / Organization" [class.is-invalid]="isFormControlInvalid('College')"
                      aria-describedby="collegeError" />
                    <div id="collegeError" *ngIf="isFormControlInvalid('College')" class="invalid-feedback">
                      {{ getErrorMessage('College') }}
                    </div>
                  </div>
                </div>

                <!-- Qualification Field -->
                <div class="col-md-6 form-line">
                  <div class="form-group">
                    <input type="text" class="form-control" id="Qualification" formControlName="Qualification"
                      placeholder="Qualification" [class.is-invalid]="isFormControlInvalid('Qualification')"
                      aria-describedby="qualificationError" />
                    <div id="qualificationError" *ngIf="isFormControlInvalid('Qualification')" class="invalid-feedback">
                      {{ getErrorMessage('Qualification') }}
                    </div>
                  </div>
                </div>

                <!-- Position Field -->
                <div class="col-md-6 form-line">
                  <div class="form-group">
                    <input type="text" class="form-control" id="position" formControlName="position"
                      placeholder="Designation(Optional)" />
                  </div>
                </div>



                <!-- Submit Button -->
                <div class="col-md-12">
                  <div class="form-submit">
                    <button type="submit" class="btn btn-common" [disabled]="form.invalid || isSubmitting">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </form>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--====== Carousels Start Here ======-->
<section>
  <div class="testimonial-slider-area pt-5">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="section-title-wrap text-center section-space--mb_40">
            <h6 class="section-sub-title mb-20">What Our Employees Say</h6>
            <p class="wow fadeInDown animated" data-wow-delay="0.2s"
            style="visibility: visible;-webkit-animation-delay: 0.2s; -moz-animation-delay: 0.2s; animation-delay: 0.2s;">
            Let's take a moment to explore how our events have truly been transformative for numerous individuals. It's quite the story! 
          </p>
          </div>
          <div class="testimonial-slider">
            <swiper-container #empSwiperContainer class="testimonial-slider__container" slides-per-view="2"
              [autoplay]="{ delay: 3000 }" [pagination]="{ el: '.swiper-pagination', clickable: true }" [loop]="true"
              [breakpoints]="swiperBreakpoints">
              <!-- Loop through testimonials -->
              <swiper-slide *ngFor="let testimonial of testimonials"
                class="brand-logo brand-logo--slider employee-slider">
                <div class="recognition-employees testimonial-slider__one wow move-up">

                  <div class="global_section_content recognition-slider testimonial-slider__text">
                    {{ testimonial.comment }}
                  </div>
                  <div class="testimonial-slider--info">
                    <div class="testimonial-slider__author">
                      <div class="author-info">
                        <h4 class="name">{{ testimonial.name }}</h4>
                        <div>
                          <p class="designation">{{ testimonial.designation }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </swiper-slide>
            </swiper-container>

          </div>
        </div>
      </div>
    </div>
  </div>

</section>

<!--====== Carousels End Here ======-->

